import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class ProfileCorrectionApi {
  // GET /api//profile-corrections
  getProfileCorrections = async (params) => {
    try {
      const response = await api.get("/profile-corrections", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch profile corrections. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  // GET /api//profile-corrections/:id
  getProfileCorrectionById = async (id) => {
    try {
      const response = await api.get(`/profile-corrections/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch correction details. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  // PUT /api//profile-corrections/:id/status
  updateProfileCorrectionStatus = async (id, data) => {
    try {
      const response = await api.put(
        `/profile-corrections/${id}/status`,
        data
      );
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update correction status. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const profileCorrectionApi = new ProfileCorrectionApi();
export default profileCorrectionApi;

export const getProfileCorrections =
  profileCorrectionApi.getProfileCorrections;
export const getProfileCorrectionById =
  profileCorrectionApi.getProfileCorrectionById;
export const updateProfileCorrectionStatus =
  profileCorrectionApi.updateProfileCorrectionStatus;
